import { observer } from 'mobx-react-lite';

import {
  IcAd16Icon,
  IcAlbum16Icon,
  IcAudio16Icon,
  IcContact16Icon,
  IcFile16Icon,
  IcImage16Icon,
  IcLocation16Icon,
  IcSticker16Icon,
  IcVideo16Icon,
  IcVoice16Icon,
} from '@gem/icons/messages';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { CommonPayload } from '../CommonPayload/CommonPayload';

const iconComponents = {
  [PayloadType.Image]: IcImage16Icon,
  [PayloadType.Video]: IcVideo16Icon,
  [PayloadType.Album]: IcAlbum16Icon,
  [PayloadType.File]: IcFile16Icon,
  [PayloadType.AudioMessage]: IcAudio16Icon,
  [PayloadType.VoiceMessage]: IcVoice16Icon,
  [PayloadType.Sticker]: IcSticker16Icon,
  [PayloadType.Location]: IcLocation16Icon,
  [PayloadType.Contact]: IcContact16Icon,
  [PayloadType.Advertisement]: IcAd16Icon,
};

export const DefaultPayload = observer(({ name, payload }) => {
  const comment = String(payload?.comment || '').trim();

  return (
    <CommonPayload
      Icon={iconComponents[payload?.payloadType] || null}
      name={name}
      description={comment || payload?.text || payload?.typeDescription || ''}
    />
  );
});
